<template>
    <v-dialog v-model="show" @click:outside="close" width="785px">
        <div class="modal">
            <div class="d-flex justify-space-between">
                <v-btn
                        class="btn-blanco few mr-6"
                        @click="close"
                        style="width: 65px !important;font-weight: 700 !important;font-size: 35px;letter-spacing: 0.94px;position: absolute;border: medium none;right: -35px;"
                        :disabled="status === 'loading'"
                        :loading="status === 'loading'"
                >X
                </v-btn>
            </div>
            <v-row>
                <div class="icon-modal table-cell">
                    <v-layout class="align-center">
                        <v-flex>
                            <img :src="require('@/assets/img/warning.svg')" alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content">
                    <div class="d-flex justify-space-between">
                        <h6 class="modal-title mb-5">Congratulations!</h6>
                    </div>

                    Your push notification was sent.

                    <div class="mt-8 mb-9 buttons d-flex">
                        <v-btn
                                class="btn-blanco few mt-5"
                                rounded
                                depressed
                                @click="close"
                                style="width:160px; display:none"
                        >Ok
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        props: ['show', 'hide'],
        data: () => ({
            image: require("@/assets/logo.svg"),
            status:''
        }),
        computed: {
            ...
                mapState({
                    total_receptors: state => state.Push_notifications.total_receptors,
                })
        },
        components: {},
        methods: {
            close: function () {
                this.hide();
            }
        },
    };
</script>
